import { ReactNode } from 'react';
import { useAppSelector } from 'app/store';
import { ROLE_SUPER_ADMIN, ROLE_TENANT_ADMIN } from '../../constants';

/** TENANT_ADMIN without SUPER_ADMIN (sensitive product sections hidden in UI). */
export function isPureTenantAdmin(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return Boolean(groups?.includes(ROLE_TENANT_ADMIN)) && !groups?.includes(ROLE_SUPER_ADMIN);
}

export function HideFromPureTenantAdmin({ children }: { children: ReactNode }) {
  if (isPureTenantAdmin()) {
    return null;
  }
  return <>{children}</>;
}
